import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  PutOrganisationsBoardsQueueRequestType,
  PutOrganisationsBoardsQueueResponseType,
} from '../types';

export const putOrganisationsBoardsQueue = async (
  params: PutOrganisationsBoardsQueueRequestType,
) => {
  const url = `/api/v2/organisations/${params.organisationId}/boards/${params.boardId}/queue`;
  const response =
    await apiAuthClient.put<PutOrganisationsBoardsQueueResponseType>(
      url,
      params.queue,
    );

  return response.data;
};
